
import authService from "@/api/authService";
import MessageService from "@/utils/message";
import tokenService from "@/utils/tokenService";
import { computed, onMounted } from "@vue/runtime-core";
import { message } from "ant-design-vue";
import { random } from "lodash";
import { toRefs } from "vue";
import { Options, setup, Vue } from "vue-class-component";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
const menuJson = require("@/assets/js/menu.json")

@Options({
  name: "logout",
})
export default class Logout extends Vue {
  info = setup(() => {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const {getTargetUrl} = toRefs(store.getters);

    const randomStr = (len:number)=>{
      len = len || 6;
      let arr:any = [];
      for(let i=0;i<len;i++){
        let code = Math.ceil(Math.random() * 58) + 65
        console.log('code', code)
        arr.push(code)
      }
      return arr.map((el:any) => {return String.fromCharCode(el)}).join('');
    }

    const getTicket = () => {
      let url = getTargetUrl.value;
      tokenService.removeToken();
      setTimeout(() => {
        window.location.href = `https://wxct.wxskii.com:8655/wui/index.html#/?appid=b6dd4071-1bb8-4adc-a4bd-21372a2f6caa&service=${encodeURIComponent(url)}&_key=${randomStr(6)}`;
      }, 1000)
    }

    onMounted(() => {
      getTicket();
    })
    return {};
  });
}
